export default __webpack_public_path__ + "static/media/webiner3.9ed64b05.jpg";